import { useEffect } from 'react'
import {
  ESC_KEY,
  ENTER_KEY,
  ARROW_UP_KEY,
  ARROW_DOWN_KEY,
} from 'constants/key-codes'

export type SearchItem = {
  img?: JSX.Element
  emoji?: string
  name?: string
  displayName?: string
}

type Props = {
  skip: boolean
  activeTag: number
  searchData: SearchItem[]
  onClose(): void
  onSelectTag(tag: string): void
  onUpdateActiveTag(func: (n: number) => number): void
}

const useArrowsNavigation = ({
  skip,
  activeTag,
  searchData,
  onClose,
  onSelectTag,
  onUpdateActiveTag,
}: Props) => {
  const guardTagIndex = (index: number) =>
    Math.min(Math.max(index, -1), searchData.length - 1)

  const handleArrowKeysDown = (evt: KeyboardEvent) => {
    switch (evt.key) {
      case ENTER_KEY: {
        searchData[activeTag] && onSelectTag(searchData[activeTag].name || '')
        onClose()
        evt.preventDefault()
        break
      }
      case ARROW_DOWN_KEY: {
        onUpdateActiveTag((tag) => guardTagIndex(tag + 1))
        evt.preventDefault()
        break
      }
      case ARROW_UP_KEY: {
        onUpdateActiveTag((tag) => guardTagIndex(tag - 1))
        evt.preventDefault()
        break
      }
      case ESC_KEY:
        onClose()
        break
    }
  }

  useEffect(() => {
    if (skip) return

    window.addEventListener('keydown', handleArrowKeysDown, false)
    return () => window.removeEventListener('keydown', handleArrowKeysDown)
  }, [activeTag, skip])
}

export default useArrowsNavigation
